import { Sites } from '@ps/platform-message-framework/common/Sites';
import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import { Translation } from '@ps/web-shared-components';
import { StarsInfo, createForm } from '@ps/web-shared-ui';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { styles as sharedStyles } from '@swf/account';
import { getEulaTypes } from '@swf/components/RegulatoryCheckboxes/RegulatoryCheckboxes';
import useSearchParams from '@swf/core/hooks/useSearchParams';
import type { RegisterPayload } from '@swf/core/models/auth/register';
import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

import { RegistrationStyles } from '../../StarsAuth';

import {
  TXTCLI_For_the_purposes_of_responsibl_ELL,
  TXTCLI_If_you_are_interested_in_imple_ELL,
  TXTWCL_Nearly_doneX
} from './RegistrationEula.messages.json';
import type { RegistrationEulaFormValues } from './RegistrationEulaFields';
import RegistrationEulaFields from './RegistrationEulaFields';

const getInitialValues = (siteId: Sites, separatedEulaPrivacyPolicy: boolean) => ({
  marketingMailList: false,
  selectAll: false,
  ...getEulaTypes('stars', siteId, separatedEulaPrivacyPolicy).reduce(
    (result, el) => ({ ...result, [el]: false }),
    {}
  )
});

const Form = createForm<RegistrationEulaFormValues>();

const RegistrationEula: React.FC = () => {
  const searchParams = useSearchParams<Omit<RegisterPayload, 'marketingMailList'>>();
  const siteId = useSelector(select.cms.getSiteId);
  const separatedEulaPrivacyPolicy = useFeature(FeatureFlag.SeparatedEulaPrivacyPolicy);
  const {
    auth: { register }
  } = useDispatch<Dispatch>();

  const handleSubmit = useCallback(
    ({ marketingMailList = false }: { marketingMailList: boolean }) =>
      register({ marketingMailList, ...searchParams }),
    [register, searchParams]
  );

  return (
    <RegistrationStyles.Consumer>
      {(registrationStyles) => (
        <>
          <h2 className={registrationStyles.title}>
            <Translation {...TXTWCL_Nearly_doneX} />
          </h2>
          <Form
            onSubmit={handleSubmit}
            initialValues={getInitialValues(siteId, separatedEulaPrivacyPolicy)}
          >
            <RegistrationEulaFields />
          </Form>
          {siteId === Sites.US_NJ && (
            <div className={sharedStyles.message}>
              <StarsInfo>
                <Translation {...TXTCLI_For_the_purposes_of_responsibl_ELL} />{' '}
                <Translation {...TXTCLI_If_you_are_interested_in_imple_ELL} />
              </StarsInfo>
            </div>
          )}
        </>
      )}
    </RegistrationStyles.Consumer>
  );
};

export default RegistrationEula;
